import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  beginInteractiveSignin,
  recoverSession,
} from "../../services/authRecoveryService";

const isIdempotentRequest = (args) => {
  const normalizedArgs = typeof args === "string" ? { url: args } : args;
  const method = (normalizedArgs.method || "GET").toUpperCase();
  return method === "GET" || method === "HEAD";
};

const prepareCurrentHeaders = (getHeaders) => (headers) => {
  Object.entries(getHeaders()).forEach(([name, value]) => {
    if (value !== undefined && value !== null) {
      headers.set(name, value);
    }
  });
  return headers;
};

export const createAuthenticatedBaseQuery = ({
  baseUrl,
  getHeaders,
  maxGatewayRetries = 0,
  gatewayRetryStatuses = [502, 503, 504],
  handleError,
}) => {
  const rawBaseQuery = fetchBaseQuery({
    baseUrl,
    prepareHeaders: prepareCurrentHeaders(getHeaders),
  });

  const executeWithGatewayRetry = async (args, api, extraOptions) => {
    const attempts = isIdempotentRequest(args) ? maxGatewayRetries + 1 : 1;
    let result;

    for (let attempt = 0; attempt < attempts; attempt += 1) {
      result = await rawBaseQuery(args, api, extraOptions);
      const shouldRetry =
        gatewayRetryStatuses.includes(result?.error?.status) &&
        attempt < attempts - 1;

      if (!shouldRetry) {
        break;
      }
    }

    return result;
  };

  return async (args, api, extraOptions) => {
    let result = await executeWithGatewayRetry(args, api, extraOptions);

    if (result?.error?.status === 401) {
      const sessionRecovered = await recoverSession();
      if (sessionRecovered) {
        result = await rawBaseQuery(args, api, extraOptions);
        if (result?.error?.status === 401) {
          beginInteractiveSignin();
        }
      }
    }

    if (result?.error && handleError) {
      handleError(result.error);
    }

    return result;
  };
};
